import actionCreatorFactory from 'typescript-fsa'

const action = actionCreatorFactory()

export const startPolling = action('START_POLLING')
export const stopPolling = action('STOP_POLLING')
